module.exports = __webpack_public_path__ + "static/media/Pretty-badass.c4fed6a3.jpg";